<template>
  <div class="w-100">
    <!-- FULL SCREEN SAVING MODAL -->
    <div
      v-if="loading"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.75); z-index: 9999; display: flex; flex-direction: column; justify-content: center; align-items: center; color: white;"
    >
      <LoadingSpinner style="transform: scale(1.5); margin-bottom: 25px;" />
      <h3 style="color: white; font-weight: bold; margin-top: 15px;">
        Saving, please wait...
      </h3>
    </div>
    <NavbarTop v-if="showNavbar" />
    <router-view />
    <FooterPage v-if="showFooter" />
    <CookieConsent />
    <div
      v-if="authLoading"
      class="container text-center mt-5"
    >
      <PreLoader />
    </div>
    <div
      v-else
      class="container-fluid mt-5"
    >
      <div
        v-if="auth.currentUser"
        id="petaddlisting"
      >
        <div class="add-listing p-5">
          <div class="container-fluid">
            <p>
              Hello {{ userInfo.displayName }} - Your pet ad limit is: {{ adLimit }} ({{
                activeListingsCount
              }}
              currently active, {{ adLeft }} remaining)
            </p>
          </div>
          
          <form @submit.prevent="petSubmit">
            <!-- Adım 1: Kategori Seçimi -->
            <div
              class="step-section"
              :class="{ active: currentStep === 1 }"
            >
              <div class="form-check">
                Select Category: {{ userInfo.latitude }} - {{ userInfo.longitude }}
                <span v-if="selectedCategory.id"><small>
                  (ID: {{ selectedCategory.id }}, Name: {{ selectedCategory.name }})</small></span>
                <span v-else>[Please Select a Main Category]</span>
                <select
                  id="category"
                  v-model="selectedCategory"
                  class="form-select"
                  required
                  @change="onCategoryChange"
                >
                  <option
                    :value="{ id: '', name: '' }"
                    disabled
                  >
                    Select a category
                  </option>
                  <option
                    v-for="category in sortedCategories"
                    :key="category.id"
                    :value="{ id: category.id, name: category.name }"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>

              <div class="form-check mt-3">
                <label for="subCategory">
                  Select Sub Category:
                  <span v-if="selectedSubCategory">{{ selectedSubCategory }}</span>
                  <span v-else>[Seçilmedi]</span>
                </label>
                <select
                  id="subCategory"
                  v-model="selectedSubCategory"
                  class="form-select"
                  required
                >
                  <option
                    value=""
                    disabled
                  >
                    Select a sub category
                  </option>
                  <option
                    v-for="subCategory in subCategories"
                    :key="subCategory"
                    :value="subCategory"
                  >
                    {{ subCategory }}
                  </option>
                </select>
              </div>

              <div
                v-if="categoryCoatPatterns.length > 0"
                class="form-check mt-3"
              >
                <label for="coatPattern">
                  Coat Pattern / Marking:
                  <span v-if="coat_pattern">{{ coat_pattern }}</span>
                  <span v-else>[Opsiyonel]</span>
                </label>
                <select
                  id="coatPattern"
                  v-model="coat_pattern"
                  class="form-select"
                >
                  <option
                    value=""
                    disabled
                  >
                    Select pattern
                  </option>
                  <option
                    v-for="pattern in categoryCoatPatterns"
                    :key="pattern"
                    :value="pattern"
                  >
                    {{ pattern }}
                  </option>
                </select>
              </div>

              <div
                v-if="categoryColors.length > 0"
                class="form-check mt-3"
              >
                <label for="color">
                  Color:
                  <span v-if="color">{{ color }}</span>
                  <span v-else>[Opsiyonel]</span>
                </label>
                <select
                  id="color"
                  v-model="color"
                  class="form-select"
                >
                  <option
                    value=""
                    disabled
                  >
                    Select color
                  </option>
                  <option
                    v-for="c in categoryColors"
                    :key="c"
                    :value="c"
                  >
                    {{ c }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Adım 2: Resim Yükleme (Kategori seçimi tamamlandığında görünür) -->
            <div
              v-if="documentId"
              class="step-section"
              style="position: relative;"
            >
              <!-- AI CHECKING OVERLAY -->
              <div
                v-if="isCheckingImages || aiWarningMessage"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.95); z-index: 100; display: flex; flex-direction: column; justify-content: center; align-items: center; border-radius: 5px; text-align: center; padding: 20px;"
              >
                <template v-if="isCheckingImages">
                  <LoadingSpinner />
                  <h4 style="margin-top: 15px; color: #333; font-weight: bold;">
                    Checking picture with AI...
                  </h4>
                </template>
                <template v-else-if="aiWarningMessage">
                  <i
                    class="fas fa-exclamation-triangle"
                    style="font-size: 45px; color: #e74c3c; margin-bottom: 15px;"
                  />
                  <h4 style="color: #333; font-weight: bold; margin-bottom: 10px;">
                    Image Rejected
                  </h4>
                  <p style="color: #666; margin-bottom: 20px; max-width: 80%;">
                    {{ aiWarningMessage }}
                  </p>
                  <button 
                    type="button"
                    class="btn color-bg" 
                    style="padding: 10px 25px; border-radius: 5px;"
                    @click="aiWarningMessage = null"
                  >
                    Got It
                  </button>
                </template>
              </div>

              <div class="form-check">
                <label for="images">Upload Images (Max {{ MAX_IMAGES }}) - Remaining: {{ remainingImages }}:</label>
                <div>{{ error }}</div>
                <div
                  class="col-md-4"
                  style="display: flex"
                >
                  <div class="add-list-media-wrap">
                    <form class="fuzone">
                      <div class="fu-text">
                        <span><i class="fas fa-image" /> Click here or drop files to upload</span>
                        <div class="photoUpload-files fl-wrap" />
                      </div>
                      <input
                        id="images"
                        :disabled="remainingImages <= 0"
                        type="file"
                        multiple
                        accept="image/*"
                        class="form-control"
                        @change="handleImageUpload"
                      >
                    </form>
                  </div>
                </div>
              </div>

              <div
                v-if="images.length > 0 || processingImages.length > 0"
                class="image-preview"
              >
                <draggable
                  v-model="images"
                  class="draggable-grid"
                  item-key="url"
                  @end="handleDragEnd"
                >
                  <template #item="{ element, index }">
                    <div class="image-item">
                      <div
                        class="image-wrapper"
                        style="position: relative"
                      >
                        <img
                          :src="element.url"
                          alt="Preview"
                        >
                        <button
                          type="button"
                          class="delete-button"
                          :disabled="element.uploading || loading"
                          @click.stop="deleteImage(element, index)"
                        >
                          <i class="fas fa-trash" />
                        </button>
                        <div
                          v-if="element.uploading"
                          class="spinner-overlay"
                        >
                          <LoadingSpinner />
                        </div>
                      </div>
                      <button
                        type="button"
                        class="selection-button"
                        :class="{ 'cover-selected': element.isCover }"
                        @click="setCoverImage(index)"
                      >
                        {{ element.isCover ? 'Cover Image' : 'Set as Cover' }}
                      </button>
                    </div>
                  </template>
                </draggable>

                <!-- Processing Images Placeholders -->
                <div
                  v-if="processingImages.length > 0"
                  class="draggable-grid"
                >
                  <div
                    v-for="img in processingImages"
                    :key="img.id"
                    class="image-item"
                  >
                    <div
                      class="image-wrapper"
                      style="position: relative; display: flex; align-items: center; justify-content: center; background: #f0f0f0;"
                    >
                      <div
                        class="spinner-overlay"
                        style="background: rgba(255,255,255,0.7); flex-direction: column;"
                      >
                        <LoadingSpinner />
                        <span style="font-size: 12px; font-weight: bold; color: #333; margin-top: 10px; text-align: center;">AI Checking...</span>
                      </div>
                    </div>
                    <div class="image-actions">
                      <button
                        type="button"
                        class="set-cover-button"
                        disabled
                      >
                        Checking...
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Adım 3: Diğer Bilgiler (Resimler yüklendiğinde görünür) -->
            <div
              v-if="images.length > 0"
              class="step-section"
            >
              <!-- Mevcut diğer input alanları buraya gelecek -->
              <!-- Diğer Inputlar -->
              <div v-if="selectedSubCategory">
                <div class="mb-3 petselldetails">
                  <!-- Choose ad type / For sell / Re homing / For Stud -->
                  <h5>Choose ad type</h5>
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="typeForSell"
                          class="form-check-input"
                          type="checkbox"
                          name="adType"
                          value="For Sell"
                          :checked="adType === 'For Sell'"
                          @change="handleAdTypeChange('For Sell')"
                        >
                        <label
                          class="form-check-label"
                          for="typeForSell"
                        > For sell </label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="typeForStud"
                          class="form-check-input"
                          type="checkbox"
                          name="adType"
                          value="For Stud"
                          :checked="adType === 'For Stud'"
                          @change="handleAdTypeChange('For Stud')"
                        >
                        <label
                          class="form-check-label"
                          for="typeForStud"
                        > For Stud </label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="typeReHoming"
                          class="form-check-input"
                          type="checkbox"
                          name="adType"
                          value="Re Homing"
                          :checked="adType === 'Re Homing'"
                          @change="handleAdTypeChange('Re Homing')"
                        >
                        <label
                          class="form-check-label"
                          for="typeReHoming"
                        > Re-homing </label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- age -->
                <div class="mb-3 p-5">
                  <label for="ageGroup">Age Group:</label>
                  <select
                    id="ageGroup"
                    v-model="ageGroup"
                    class="form-select mb-3"
                    required
                  >
                    <option
                      value=""
                      disabled
                    >
                      Select age group
                    </option>
                    <option
                      v-for="group in ageGroups"
                      :key="group"
                      :value="group"
                    >
                      {{ group }}
                    </option>
                  </select>

                  <label for="age">Exact Date of Birth (Optional):</label>
                  <input
                    id="age"
                    v-model="birthDate"
                    class="form-control"
                    type="date"
                  >
                </div>
                <!-- gender -->
                <div class="mb-3 petselldetails">
                  <h5>Choose gender</h5>
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="genderMale"
                          class="form-check-input"
                          type="checkbox"
                          name="genderGroup"
                          value="male"
                          :checked="gender === 'male'"
                          @change="handleGenderChange('male')"
                        >
                        <label
                          class="form-check-label"
                          for="genderMale"
                        > Male </label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="genderFemale"
                          class="form-check-input"
                          type="checkbox"
                          name="genderGroup"
                          value="female"
                          :checked="gender === 'female'"
                          @change="handleGenderChange('female')"
                        >
                        <label
                          class="form-check-label"
                          for="genderFemale"
                        > Female </label>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-check">
                        <input
                          id="genderUnknown"
                          class="form-check-input"
                          type="checkbox"
                          name="genderGroup"
                          value="unknown"
                          :checked="gender === 'unknown'"
                          @change="handleGenderChange('unknown')"
                        >
                        <label
                          class="form-check-label"
                          for="genderUnknown"
                        >
                          I don't know / Mixed Litter
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                  class="container p-5"
                >
                  <!-- Neutered, Microchipped, Vaccinated, Worm Treated, Health Checked -->
                  <div class="mb-3">
                    <h5>Additional Information</h5>
                    <div class="petselldetails">
                      <!-- Neutered -->
                      <div class="col">
                        <label>Neutered:</label>
                        <div class="form-check">
                          <input
                            id="neuteredNo"
                            v-model="isNeutered"
                            class="form-check-input"
                            type="checkbox"
                            value="0"
                            true-value="false"
                            false-value="true"
                          >
                          <label
                            class="form-check-label"
                            for="neuteredNo"
                          >No</label>
                        </div>
                        <div class="form-check">
                          <input
                            id="neuteredYes"
                            v-model="isNeutered"
                            class="form-check-input"
                            type="checkbox"
                            value="1"
                            true-value="true"
                            false-value="false"
                          >
                          <label
                            class="form-check-label"
                            for="neuteredYes"
                          >Yes</label>
                        </div>
                      </div>

                      <!-- Microchipped -->
                      <div class="col">
                        <label>Microchipped:</label>
                        <div class="form-check">
                          <input
                            id="microchippedNo"
                            v-model="isMicrochipped"
                            class="form-check-input"
                            type="checkbox"
                            value="0"
                            true-value="false"
                            false-value="true"
                          >
                          <label
                            class="form-check-label"
                            for="microchippedNo"
                          >No</label>
                        </div>
                        <div class="form-check">
                          <input
                            id="microchippedYes"
                            v-model="isMicrochipped"
                            class="form-check-input"
                            type="checkbox"
                            value="1"
                            true-value="true"
                            false-value="false"
                          >
                          <label
                            class="form-check-label"
                            for="microchippedYes"
                          >Yes</label>
                        </div>
                      </div>

                      <!-- Vaccinated -->
                      <div class="col">
                        <label>Vaccinated:</label>
                        <div class="form-check">
                          <input
                            id="vaccinatedNo"
                            v-model="isVaccinated"
                            class="form-check-input"
                            type="checkbox"
                            value="0"
                            true-value="false"
                            false-value="true"
                          >
                          <label
                            class="form-check-label"
                            for="vaccinatedNo"
                          >No</label>
                        </div>
                        <div class="form-check">
                          <input
                            id="vaccinatedYes"
                            v-model="isVaccinated"
                            class="form-check-input"
                            type="checkbox"
                            value="1"
                            true-value="true"
                            false-value="false"
                          >
                          <label
                            class="form-check-label"
                            for="vaccinatedYes"
                          >Yes</label>
                        </div>
                      </div>

                      <!-- Worm Treated -->
                      <div class="col">
                        <label>Worm Treated:</label>
                        <div class="form-check">
                          <input
                            id="wormTreatedNo"
                            v-model="isWormTreated"
                            class="form-check-input"
                            type="checkbox"
                            value="0"
                            true-value="false"
                            false-value="true"
                          >
                          <label
                            class="form-check-label"
                            for="wormTreatedNo"
                          >No</label>
                        </div>
                        <div class="form-check">
                          <input
                            id="wormTreatedYes"
                            v-model="isWormTreated"
                            class="form-check-input"
                            type="checkbox"
                            value="1"
                            true-value="true"
                            false-value="false"
                          >
                          <label
                            class="form-check-label"
                            for="wormTreatedYes"
                          >Yes</label>
                        </div>
                      </div>

                      <!-- Health Checked -->
                      <div class="col">
                        <label>Health Checked:</label>
                        <div class="form-check">
                          <input
                            id="healthCheckedNo"
                            v-model="isHealthChecked"
                            class="form-check-input"
                            type="checkbox"
                            value="0"
                            true-value="false"
                            false-value="true"
                          >
                          <label
                            class="form-check-label"
                            for="healthCheckedNo"
                          >No</label>
                        </div>
                        <div class="form-check">
                          <input
                            id="healthCheckedYes"
                            v-model="isHealthChecked"
                            class="form-check-input"
                            type="checkbox"
                            value="1"
                            true-value="true"
                            false-value="false"
                          >
                          <label
                            class="form-check-label"
                            for="healthCheckedYes"
                          >Yes</label>
                        </div>
                      </div>
                    </div>
                    <!-- Row end -->
                  </div>
                  <div
                    v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                  >
                    <label for="bloodType">Select Blood Type:</label>
                    <select
                      id="bloodType"
                      v-model="bloodType"
                      class="form-select"
                      required
                    >
                      <option
                        value=""
                        disabled
                      >
                        Select a blood type
                      </option>
                      <option
                        v-for="type in bloodTypes"
                        :key="type"
                        :value="type"
                      >
                        {{ type }}
                      </option>
                      <option value="I don't know">
                        I don't know
                      </option>
                      <!-- Kullanıcı bilmiyorsa bu seçeneği seçebilir -->
                    </select>
                  </div>
                  <div
                    v-if="selectedCategory.name === 'Cats' || selectedCategory.name === 'Dogs'"
                  >
                    <label for="certificate">Select certificate:</label>
                    <select
                      id="certificate"
                      v-model="certificate"
                      class="form-select"
                      required
                    >
                      <option
                        value=""
                        disabled
                      >
                        Select certificate
                      </option>
                      <option
                        v-for="type in certificates"
                        :key="type"
                        :value="type"
                      >
                        {{ type }}
                      </option>
                      <option value="No certificate">
                        No certificate
                      </option>
                      <!-- Kullanıcı bilmiyorsa bu seçeneği seçebilir -->
                    </select>
                  </div>
                </div>

                <!-- ---START---  Title / Description / Price -->
                <div class="step-section">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4 class="m-0">
                      Title & Description
                    </h4>
                    <button
                      v-if="!isEditingText"
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      @click="isEditingText = true"
                    >
                      <i class="fas fa-edit" /> Edit
                    </button>
                    <button
                      v-else
                      type="button"
                      class="btn btn-success btn-sm"
                      :disabled="textCheckLoading"
                      @click="moderateText"
                    >
                      <i class="fas fa-check" /> <span v-if="textCheckLoading">Checking...</span><span v-else>Done Edit</span>
                    </button>
                  </div>
                    
                  <div
                    v-if="textCheckError"
                    class="alert alert-danger"
                  >
                    {{ textCheckError }}
                  </div>
                  <div
                    v-if="textCheckMessage"
                    class="alert alert-success"
                  >
                    {{ textCheckMessage }}
                  </div>

                  <div class="form-check">
                    <label
                      class="form-check-label"
                      for="title"
                    >Title:</label>
                    <input
                      id="title"
                      v-model="title"
                      class="form-control"
                      type="text"
                      :disabled="!isEditingText"
                      required
                    >
                  </div>
                  <div class="form-check">
                    <label
                      class="form-check-label"
                      for="description"
                    >Description:</label>
                    <textarea
                      id="description"
                      v-model="description"
                      class="form-control"
                      rows="18"
                      :disabled="!isEditingText"
                      required
                    />
                  </div>
                  <div class="form-check">
                    <label
                      class="form-check-label"
                      for="price"
                    >Price:</label>
                    <input
                      id="price"
                      v-model="price"
                      class="form-control"
                      type="number"
                      required
                    >
                  </div>
                </div>
                <!-- ---END--- Title / Description / Price  -->
                <div class="p-5">
                  <p
                    v-if="!images.length"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please load images
                  </p>
                  <p
                    v-if="coverImageIndex === null"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please select a cover image
                  </p>
                  <p
                    v-if="title === ''"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please write title
                  </p>
                  <p
                    v-if="description === ''"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please write description
                  </p>
                  <p
                    v-if="images.length && coverImageIndex !== null"
                    class="p-2 bg-light border"
                    style="color: green"
                  >
                    Images Ready!
                  </p>
                  <p
                    v-if="!birthDate"
                    class="p-2 bg-light border"
                    style="color: red"
                  >
                    Please choose birth date
                  </p>
                  <button
                    class="btn btn-primary mt-3 mb-5"
                    type="submit"
                    :disabled="
                      loading ||
                        !images.length ||
                        !birthDate ||
                        coverImageIndex === null ||
                        title === '' ||
                        description === '' ||
                        images.some((image) => image.uploading)
                    "
                  >
                    {{ loading ? 'Saving...' : 'Save Listing' }}
                  </button>

                  <div
                    v-if="error"
                    class="error"
                  >
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, watch } from 'vue';
  import { getAuth, onAuthStateChanged } from 'firebase/auth';
  import { getFunctions, httpsCallable } from 'firebase/functions';
  import { onBeforeRouteLeave } from 'vue-router';
  import {
    collection,
    serverTimestamp,
    doc,
    getDocs,
    getDoc,
    GeoPoint,
  } from 'firebase/firestore';
  import {
    getStorage,
    ref as storageRef,
    uploadBytesResumable,
    getDownloadURL,
    deleteObject,
  } from 'firebase/storage';
  import { db } from '@/firebase'; 
  import { updatePetListing, getPetListingById, getActiveListingsCount } from '@/services/petService';
  import { useRouter, useRoute } from 'vue-router';
  import LoadingSpinner from './LoadingSpinner.vue';
  import { reactive } from 'vue';
  import PreLoader from './PreLoader.vue';
  import draggable from 'vuedraggable';
  import { useDeviceStore } from '@/stores/deviceStore';
  import { compressImage } from '@/utils/imageUtils';

  import NavbarTop from '@/components/NavbarTop.vue';
  import FooterPage from '@/components/FooterPage.vue';
  import CookieConsent from '@/components/CookieConsent.vue';

  const showNavbar = ref(false);
  const showFooter = ref(false);
  const deviceStore = useDeviceStore();

  const title = ref('');
  const description = ref('');
  const price = ref(0);
  const images = ref([]);
  const coverImageIndex = ref(null);
  const error = ref(null);
  const loading = ref(false);
  const router = useRouter();
  const route = useRoute();
  const auth = getAuth();
  const storage = getStorage();
  const functions = getFunctions();
  const userInfo = ref(null);
  

  const isEditingText = ref(false);
  const isCheckingImages = ref(false);
  const aiWarningMessage = ref(null);
  const processingImages = ref([]);
  const textCheckMessage = ref('');
  const textCheckError = ref('');
  const textCheckLoading = ref(false);
  const pendingUploads = ref([]);
  const pendingDeletions = ref([]);
  const hasUnsavedChanges = ref(false);
  const isNeutered = ref(false); // Varsayılan olarak "No" seçili
  const isMicrochipped = ref(false);
  const isVaccinated = ref(false);
  const isWormTreated = ref(false);
  const isHealthChecked = ref(false);
  const gender = ref('unknown'); // Gender seçimi için yeni data özelliği
  const adType = ref('Re Homing'); // Ad type seçimi için yeni data özelliği
  // Kategori ve Alt Kategori İşlemleri
  const categories = ref([]);
  const selectedCategory = ref({ id: '', name: '' }); // Hem ID hem de ismi tutalım
  const subCategories = ref([]);
  const selectedSubCategory = ref('');
  const bloodType = ref(''); // Kullanıcının seçtiği kan grubu
  const birthDate = ref(''); // Doğum tarihi
  const ageGroup = ref('');
  const coat_pattern = ref('');
  const color = ref('');
  const categoryCoatPatterns = ref([]);
  const categoryColors = ref([]);
  const ageGroups = ['0-3 Months', '3-6 Months', '6-12 Months', '1-2 Years', '2-4 Years', '4-8 Years', '8+ Years'];
  const certificate = ref(''); // Sertifikalar
  const isInitialLoad = ref(true); // <--- BU SATIRI EKLEYİN

  // Kullanıcı ilanlarını getirme fonksiyonu
  const activeListingsCount = ref(0);

  // adLimit computed property
  const adLimit = computed(() => {
    return userInfo.value?.account?.properties?.ad_limit || 3; // Varsayılan limit 3
  });
  const adLeft = computed(() => {
    return adLimit.value - activeListingsCount.value;
  });
  // Draft ilanları yükleyen fonksiyon
  const MAX_IMAGES = 20; // Maksimum resim sayısı

  const remainingImages = computed(() => {
    return MAX_IMAGES - images.value.length;
  });

  const sortedCategories = computed(() => {
    return categories.value.slice().sort((a, b) => a.order - b.order);
  });

  const bloodTypes = computed(() => {
    if (selectedCategory.value.name === 'Cats') {
      return ['A', 'B', 'AB']; // Kediler için kan grupları
    } else if (selectedCategory.value.name === 'Dogs') {
      return [
        'DEA 1.1+',
        'DEA 1.1-',
        'DEA 1.2',
        'DEA 3',
        'DEA 4',
        'DEA 5',
        'DEA 6',
        'DEA 7',
        'DEA 8',
      ]; // Köpekler için kan grupları
    }
    return [];
  });

  const certificates = computed(() => {
    if (selectedCategory.value.name === 'Dogs') {
      return [
        'Pedigree',
        'Federation Cynologique Internationale (FCI)',
        'American Kennel Club (AKC)',
        'United Kennel Club (UKC)',
        'Kennel Club of the United Kingdom (KC)',
        'Australian National Kennel Council (ANKC)',
        'Canadian Kennel Club (CKC)',
        'New Zealand Kennel Club (NZKC)',
        'Irish Kennel Club (IKC)',
        'The Kennel Club (KC)',
      ]; // Köpekler için sertifikalar
    } else if (selectedCategory.value.name === 'Cats') {
      return [
        'The International Cat Association (TICA)',
        'The Cat Fanciers’ Association (CFA)',
        'The Governing Council of the Cat Fancy (GCCF)',
        'Fédération Internationale Féline (FIFe)',
        'Australian Cat Federation (ACF)',
        'Canadian Cat Association (CCA-AFC)',
        'New Zealand Cat Fancy (NZCF)',
        'Southern Africa Cat Council (SACC)',
        'Cat Fanciers’ Federation (CFF)',
        'American Cat Fanciers Association (ACFA)',
      ]; // Kediler için sertifikalar
    }
    return [];
  });

  onMounted(async () => {
    try {
      const fetchActiveListingsCount = async (userId) => {
        try {
          activeListingsCount.value = await getActiveListingsCount(userId);
        } catch (error) {
          console.error('Error fetching active listings:', error);
        }
      };

      // Device detection
      deviceStore.detectDevice();

      const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        if (currentUser) {
          try {
            // 1. Kullanıcı bilgilerini yükle
            const userDocRef = doc(db, 'users', currentUser.uid);
            const userDocSnap = await getDoc(userDocRef);

            const propertiesDocRef = doc(db, 'users', currentUser.uid, 'account', 'properties');
            const propertiesDocSnap = await getDoc(propertiesDocRef);

            if (userDocSnap.exists()) {
              userInfo.value = userDocSnap.data();
              if (propertiesDocSnap.exists()) {
                userInfo.value.account = userInfo.value.account || {};
                userInfo.value.account.properties = propertiesDocSnap.data();
              }
              // Aktif ilanları getir
              await fetchActiveListingsCount(currentUser.uid);
            }

            // 2. Kategorileri yükle
            const categoriesSnapshot = await getDocs(collection(db, 'petcategories'));
            categories.value = categoriesSnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));

            // 3. Draft yükle
            await loadPetDocument(route.params.id);
          } catch (error) {
            console.error('Veri yükleme hatası:', error);
          }
        }
        authLoading.value = false;
      });

      // Cleanup function
      return () => unsubscribe();
    } catch (error) {
      console.error('Mount hatası:', error);
      authLoading.value = false;
    }
  });

  // Kategori seçimi değiştiğinde alt kategorileri çek
  const onCategoryChange = async () => {
    if (selectedCategory.value.id) {
      await fetchSubCategories();
    } else {
      subCategories.value = [];
    }
  };

  // Seçilen kategoriye göre alt kategorileri çek
  const fetchSubCategories = async () => {
    //console.log("Alt kategoriler çekiliyor...");
    if (!selectedCategory.value?.id) {
      console.warn('Kategori seçili değil, alt kategoriler temizlendi');
      subCategories.value = [];
      categoryCoatPatterns.value = [];
      categoryColors.value = [];
      return;
    }

    try {
      const categoryDoc = await getDoc(doc(db, 'petcategories', selectedCategory.value.id));
      if (categoryDoc.exists()) {
        const data = categoryDoc.data();
        subCategories.value = data.subcategories || [];
        categoryCoatPatterns.value = data.coat_patterns || [];
        categoryColors.value = data.colors || [];
      } else {
        console.error('Kategori dökümanı bulunamadı!');
        subCategories.value = [];
        categoryCoatPatterns.value = [];
        categoryColors.value = [];
      }
    } catch (error) {
      console.error('Alt kategori çekme hatası:', error);
      subCategories.value = [];
      categoryCoatPatterns.value = [];
      categoryColors.value = [];
    }
  };

  
  const moderateText = async () => {
    textCheckError.value = '';
    textCheckMessage.value = '';
    textCheckLoading.value = true;
    try {
      const moderateTextContent = httpsCallable(functions, 'moderateTextContent');
      const result = await moderateTextContent({ title: title.value, description: description.value });
      if (result.data.isSafe) {
        textCheckMessage.value = 'Title/description changing done, please don\'t forget to SAVE';
        isEditingText.value = false;
        hasUnsavedChanges.value = true;
      } else {
        textCheckError.value = 'AI Warning: ' + result.data.reason;
      }
    } catch (err) {
      console.error(err);
      textCheckError.value = 'Error checking text. Please try again.';
    } finally {
      textCheckLoading.value = false;
    }
  };

  onBeforeRouteLeave((to, from, next) => {
    if (hasUnsavedChanges.value || pendingUploads.value.length > 0 || pendingDeletions.value.length > 0 || isEditingText.value) {
      const answer = window.confirm('You have unsaved changes! Are you sure you want to leave?');
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  });

  const loadPetDocument = async (docId) => {
    try {
      const docSnap = await getPetListingById(docId);
      if (docSnap.exists() && docSnap.data().createdBy === auth.currentUser.uid) {
        documentId.value = docSnap.id;
        const data = docSnap.data();

        // Populate fields
        let foundCategory = null;
        if (data.categoryId) {
          foundCategory = categories.value.find((cat) => cat.id === data.categoryId);
        } else if (data.category) {
          foundCategory = categories.value.find((cat) => cat.name === data.category);
        }

        if (foundCategory) {
          isInitialLoad.value = true;
          selectedCategory.value = { id: foundCategory.id, name: foundCategory.name };
          await fetchSubCategories();
          if (data.subCategory) selectedSubCategory.value = data.subCategory;
          isInitialLoad.value = false;
        }
        
        adType.value = data.adType || 'Re Homing';
        title.value = data.title || '';
        description.value = data.description || '';
        price.value = data.price || 0;
        birthDate.value = data.birthDate || '';
        ageGroup.value = data.ageGroup || '';
        coat_pattern.value = data.coat_pattern || '';
        color.value = data.color || '';
        gender.value = data.gender || 'unknown';
        coverImageIndex.value = data.coverImageIndex || null;
        bloodType.value = data.bloodType || '';
        certificate.value = data.certificate || '';
        
        if (selectedCategory.value.name == 'Cats' || selectedCategory.value.name == 'Dogs') {
          isNeutered.value = data.isNeutered || false;
          isMicrochipped.value = data.isMicrochipped || false;
          isVaccinated.value = data.isVaccinated || false;
          isWormTreated.value = data.isWormTreated || false;
          isHealthChecked.value = data.isHealthChecked || false;
        }

        if (data.images?.length > 0) {
          data.images.forEach((imgUrl, index) => {
            images.value.push(
              reactive({
                file: null,
                url: imgUrl,
                isCover: data.coverImage === imgUrl,
                uploading: false,
                uploadUrl: imgUrl,
                uploadError: false,
              })
            );
            if (data.coverImage === imgUrl) coverImageIndex.value = index;
          });
        }
        currentStep.value = 2; // Jump to step 2 for edit
      }
    } catch (err) {
      console.error("Error loading pet doc:", err);
    }
  };


  const handleImageUpload = async (event) => {
    error.value = null;
    const files = event.target.files;
    const currentCount = images.value.length;
    const remaining = MAX_IMAGES - currentCount;

    if (files.length > remaining) {
      error.value = `You selected ${files.length} images, max allowed is ${remaining}.`;
      return;
    }

    const moderateImageContent = httpsCallable(functions, 'moderateImageContent');
    
    // Add placeholders for all newly selected files
    const newProcessing = [];
    for (let i = 0; i < files.length; i++) {
      newProcessing.push({ id: Date.now() + i, loading: true });
    }
    processingImages.value.push(...newProcessing);
    isCheckingImages.value = true;
    aiWarningMessage.value = null;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const mainImage = await compressImage(file, selectedSubCategory.value, deviceStore.isIOS, 'image');
      const thumbnail = await compressImage(file, selectedSubCategory.value, deviceStore.isIOS, 'thumbnail', mainImage.name);
      
      // Convert to base64 for AI check
      const reader = new FileReader();
      const base64Promise = new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(mainImage);
      });
      const base64Image = await base64Promise;

      try {
        const aiResult = await moderateImageContent({ imageBase64: base64Image });
        if (!aiResult.data.isSafe) {
          isCheckingImages.value = false;
          aiWarningMessage.value = "Image rejected by AI: " + aiResult.data.reason;
          processingImages.value.splice(0, 1);
          continue; // skip this image
        }
      } catch (err) {
        console.error("Image moderation failed", err);
        isCheckingImages.value = false;
        aiWarningMessage.value = "Image moderation failed. Please try again.";
        processingImages.value.splice(0, 1);
        continue;
      }

      const previewUrl = URL.createObjectURL(mainImage);
      const imageObj = reactive({
        file: mainImage,
        thumbnail: thumbnail,
        url: previewUrl,
        isCover: false,
        uploading: false,
        uploadUrl: previewUrl, // temporary
        thumbnailUrl: null,
        uploadError: false,
      });

      images.value.push(imageObj);
      pendingUploads.value.push(imageObj); // track it
      hasUnsavedChanges.value = true;
      processingImages.value.splice(0, 1);
    }
    isCheckingImages.value = false;
  };

  const setCoverImage = (index) => {
    // Seçilen resmi bul
    const selectedImage = images.value[index];

    // Diğer tüm resimlerin cover'ını false yap
    images.value.forEach((image) => {
      image.isCover = false;
    });

    // Seçilen resmi cover olarak işaretle
    selectedImage.isCover = true;

    // Seçilen resmi diziden çıkar ve başa ekle
    images.value = [selectedImage, ...images.value.filter((_, i) => i !== index)];

    // Cover index'ini güncelle (artık 0. indeks)
    coverImageIndex.value = 0;

    // Eğer documentId varsa Firestore'u güncelle
    if (documentId.value) {
      // Boş değerleri filtrele
      const validImages = images.value
        .map((img) => img.uploadUrl)
        .filter((url) => url !== undefined && url !== null);

      const validThumbnails = images.value
        .map((img) => img.thumbnailUrl)
        .filter((url) => url !== undefined && url !== null);

      // Cover değerleri kontrol et
      const coverImageUrl = selectedImage.uploadUrl || null;
      const coverThumbnailUrl = selectedImage.thumbnailUrl || null;

      // Firestore güncellemesi için veri objesi
      const updateData = {
        images: validImages,
      };

      // Thumbnail'ler varsa ekle
      if (validThumbnails.length > 0) {
        updateData.thumbnails = validThumbnails;
      }

      // Cover image varsa ekle
      if (coverImageUrl) {
        updateData.coverImage = coverImageUrl;
      }

      // Cover thumbnail varsa ekle
      if (coverThumbnailUrl) {
        updateData.coverThumbnail = coverThumbnailUrl;
      }

      updatePetListing(documentId.value, updateData).catch((err) => {
        console.error('Cover image update error:', err);
        error.value = err.message;
      });
    }
  };


  const petSubmit = async () => {
    loading.value = true;
    error.value = null;
    try {
      if (!auth.currentUser) {
        throw new Error('You must be logged in to upload images.');
      }
      
      // 1. Process pending deletions from Firebase Storage
      for (const delUrl of pendingDeletions.value) {
         try {
           const fileRef = storageRef(storage, delUrl);
           await deleteObject(fileRef);
         } catch(e) {
           console.error("Failed to delete", delUrl, e);
         }
      }

      // 2. Process pending uploads to Firebase Storage
      for (const pImage of pendingUploads.value) {
         pImage.uploading = true;
         const storageReference = storageRef(storage, `public/adimages/${documentId.value}/${pImage.file.name}`);
         let thumbReference = null;
         if (pImage.thumbnail) {
           thumbReference = storageRef(storage, `public/adimages/${documentId.value}/thumbnails/${pImage.thumbnail.name}`);
         }
         
         await uploadBytesResumable(storageReference, pImage.file);
         const downloadURL = await getDownloadURL(storageReference);
         
         let thumbDownloadURL = downloadURL;
         if (thumbReference) {
           await uploadBytesResumable(thumbReference, pImage.thumbnail);
           thumbDownloadURL = await getDownloadURL(thumbReference);
         }
         
         pImage.uploadUrl = downloadURL;
         pImage.thumbnailUrl = thumbDownloadURL;
         pImage.uploading = false;
      }

      // 3. Finalize arrays
      const validImages = [];
      const validThumbnails = [];
      images.value.forEach(img => {
        if (img.uploadUrl) validImages.push(img.uploadUrl);
        if (img.thumbnailUrl) validThumbnails.push(img.thumbnailUrl);
      });

      const coverImage = images.value.find(img => img.isCover) || images.value[0];
      const geoPoint = new GeoPoint(
        Number(userInfo.value.latitude),
        Number(userInfo.value.longitude),
      );

      const docData = {
        title: title.value,
        description: description.value,
        price: Number(price.value),
        gender: gender.value,
        bloodType: bloodType.value,
        certificate: certificate.value,
        birthDate: birthDate.value,
        category: selectedCategory.value.name,
        categoryId: selectedCategory.value.id,
        subCategory: selectedSubCategory.value,
        adType: adType.value,
        images: validImages,
        thumbnails: validThumbnails,
        coverImage: coverImage?.uploadUrl || null,
        coverThumbnail: coverImage?.thumbnailUrl || null,
        coverImageIndex: coverImageIndex.value || 0,
        lastEditedAt: serverTimestamp(),
        adLocation: geoPoint,
        ageGroup: ageGroup.value,
        coat_pattern: coat_pattern.value,
        color: color.value,
      };

      if (selectedCategory.value.name === 'Cats' || selectedCategory.value.name === 'Dogs') {
        docData.isNeutered = isNeutered.value;
        docData.isMicrochipped = isMicrochipped.value;
        docData.isVaccinated = isVaccinated.value;
        docData.isWormTreated = isWormTreated.value;
        docData.isHealthChecked = isHealthChecked.value;
      }

      await updatePetListing(documentId.value, docData);
      
      // Reset unsaved flags before routing
      hasUnsavedChanges.value = false;
      isEditingText.value = false;
      pendingUploads.value = [];
      pendingDeletions.value = [];
      
      router.push({ path: '/profile', query: { tab: 'myListing' } });
    } catch (err) {
      console.error('Save failed:', err);
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  const authLoading = ref(true);

  const handleGenderChange = (value) => {
    gender.value = value;
  };
  const handleAdTypeChange = (value) => {
    adType.value = value;
  };

  const documentId = ref(null); // Oluşturulan dökümanın ID'sini tutmak için
  const currentStep = ref(1); // Hangi adımda olduğumuzu takip etmek için

  watch([documentId, images], ([newDocId, newImages]) => {
    if (newDocId && newImages.length > 0) {
      currentStep.value = 3;
    } else if (newDocId) {
      currentStep.value = 2;
    }
  });

  // Kategori seçimi tamamlandığında ilk dökümanı oluştur
  const handleDragEnd = async () => {
    if (!auth.currentUser) return;

    try {
      // Tüm görsellerin URL'lerini kontrol et - ÖNEMLİ: URL değil uploadUrl kullanılmalı
      const validImages = images.value
        .map((img) => ({
          url: img.uploadUrl || '', // uploadUrl kullanıldığından emin ol
          thumbnailUrl: img.thumbnailUrl || '',
          isCover: img.isCover,
        }))
        .filter((img) => img.url);

      // LocalStorage'a kaydet
      const formData = {
        ...JSON.parse(localStorage.getItem(`petform_${auth.currentUser.uid}`) || '{}'),
        images: validImages,
      };

      localStorage.setItem(`petform_${auth.currentUser.uid}`, JSON.stringify(formData));

      // Ayrıca Firestore'u da güncelleyelim
      const updateData = {
        images: validImages.map((img) => img.url),
        thumbnails: validImages.map((img) => img.thumbnailUrl).filter(Boolean),
      };

      // Cover image'i güncelle
      const coverImg = validImages.find((img) => img.isCover);
      if (coverImg) {
        updateData.coverImage = coverImg.url;
        if (coverImg.thumbnailUrl) updateData.coverThumbnail = coverImg.thumbnailUrl;
      }

      await updatePetListing(documentId.value, updateData);

      // Cover index'ini güncelle
      coverImageIndex.value = images.value.findIndex((img) => img.isCover);
    } catch (err) {
      console.error('Resim sıralaması kaydedilirken hata:', err);
      error.value = 'Resim sıralaması kaydedilemedi: ' + err.message;
    }
  };

  const deleteImage = async (imageObj, index) => {
    // Just tracking locally
    images.value.splice(index, 1);
    if (coverImageIndex.value === index) {
      coverImageIndex.value = null;
    } else if (coverImageIndex.value > index) {
      coverImageIndex.value--;
    }
    
    // If it's a pending upload, just remove from pending
    const pendingIndex = pendingUploads.value.findIndex(p => p.url === imageObj.url);
    if (pendingIndex !== -1) {
      pendingUploads.value.splice(pendingIndex, 1);
    } else {
      // It's an existing image, mark for deletion on SAVE
      // Parse the Firebase storage path properly, or just store the download URL if our petSubmit deletion logic takes URLs
      // Wait, in petSubmit we did: const fileRef = storageRef(storage, delUrl);
      // Wait, delUrl needs to be a valid path if it's parsed from url.
      // But in petSubmit I did: const fileRef = storageRef(storage, delUrl);
      // If delUrl is the full HTTPS URL, storageRef(storage, "https://...") will actually WORK in the latest Firebase SDK!
      // But just to be safe, let's extract the path like old code did.
      let pathToDelete = imageObj.uploadUrl;
      const filePathMatch = imageObj.uploadUrl.match(/o\/(.+?)\?/);
      if (filePathMatch && filePathMatch[1]) {
        pathToDelete = decodeURIComponent(filePathMatch[1]);
      }
      pendingDeletions.value.push(pathToDelete);

      if (imageObj.thumbnailUrl) {
         let thumbToDelete = imageObj.thumbnailUrl;
         const thumbPathMatch = imageObj.thumbnailUrl.match(/o\/(.+?)\?/);
         if (thumbPathMatch && thumbPathMatch[1]) {
            thumbToDelete = decodeURIComponent(thumbPathMatch[1]);
         }
         pendingDeletions.value.push(thumbToDelete);
      }
    }
    hasUnsavedChanges.value = true;
  };

  // Removed unused checkListingOwner

  //end script
</script>

<style scoped>
  .fuzone {
    position: relative;
    border: 1px solid #eee;
    border-radius: 3px;
    background: #f7f9fb;
    transition: all 0.3s linear; /* 0.3slinear düzeltildi */
    margin-bottom: 10px;
    width: 100%;
    min-height: 160px;
    margin-top: 0px;
    float: left;
    cursor: pointer;
  }

  .fuzone .fu-text i {
    font-size: 44px;
    width: 100%;
    padding-bottom: 10px;
    transition: all 0.3s linear; /* 0.3slinear düzeltildi */
    color: #666;
  }
  .fuzone input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 100;
    cursor: pointer;
  }
  .custom-form input {
    margin-bottom: 20px;
  }
  .fuzone .fu-text i {
    font-size: 44px;
    width: 100%;
    padding-bottom: 10px;
    transition: all 0.3slinear;
    color: #666;
  }
  .spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 150px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .image-preview {
    display: grid;
    /* grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); */
    gap: 1rem;
    margin-top: 1rem;
  }

  .image-item {
    position: relative;
  }

  .image-item img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 4px;
  }

  .cover-selected {
    background-color: #42b983;
    color: white;
  }

  .draggable-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }

  .draggable-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    width: 100%;
  }

  .image-item {
    cursor: move;
    transition: transform 0.2s;
    background: white;
    border-radius: 4px;
    padding: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .image-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .delete-button {
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: rgba(255, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    z-index: 5;
  }

  .delete-button:hover {
    background-color: rgba(255, 0, 0, 1);
    transform: scale(1.1);
  }

  .delete-button:disabled {
    background-color: rgba(150, 150, 150, 0.7);
    cursor: not-allowed;
  }
</style>
